import { BillsContainer } from "../../containers";
import './style.scss'

function Bills() {
    return (
        <div id="bills" className="bgrStyle">
            <BillsContainer />
        </div>
    );
}
export default Bills;
